module.exports = __webpack_public_path__ + "static/media/Isha.4b7a246c.png";